import { createClient } from '@supabase/supabase-js'

const supabase = createClient('https://sjwxvpiidbfivmcuwnxx.supabase.co','eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNqd3h2cGlpZGJmaXZtY3V3bnh4Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc1MzcxNjc4NCwiZXhwIjoyMDY5MjkyNzg0fQ.nGf3sqIDhn9m5biVESTe_cgbaVPDQWqPuDue-8vPmxI');
export default supabase;
